import { ShoesState } from 'src/types'
import { canvasResetter } from 'src/util/canvas'
import { heels } from './parts/heels'
import { heelTop } from './parts/heelTop'
import { sideBase } from './parts/sideBase'
import { toeDesign } from './parts/toeDesign'
import { atomsDesign } from './parts/atomsDesign'
import { vampStrapReinforcement } from './parts/aroundLaceThrough'
import { instep } from './parts/instep'
import { foldingTongue, standingTongue } from './parts/tongue'
import { lowOpeningLinings } from './parts/tongueLinings'
import { middleCutOpening } from './parts/opening'
import { toeGuard } from './parts/toeGuard'
import { outSoles } from './parts/outSoles'
import { startInversion, undoInversion } from 'src/util/canvas'

export const drawAtomsShoesSideSurface = (ctx: CanvasRenderingContext2D | null, state: ShoesState, canvasWidth: number): void => {
  if (!ctx) return

  const isLeftToeGuard = state.toeGuard.value === 'leftToeGuard'
  if (isLeftToeGuard) {
    startInversion(ctx, canvasWidth)
  }

  ctx.strokeStyle = '#383838'
  ctx.lineWidth = 1.0
  canvasResetter(ctx) // リセット
  standingTongue(ctx, state) // ベロ
  sideBase(ctx, state) // 横側の本体カラー
  heels(ctx, state) // かかと
  heelTop(ctx, state) // かかと飾り
  lowOpeningLinings(ctx, state) // 低めのベロ裏カラー描画
  instep(ctx, state) // つま先上部カラー
  toeDesign(ctx, state) // つま先側面カラー
  outSoles(ctx, state) // アウトソール
  atomsDesign(ctx, state)
  middleCutOpening(ctx, state) // ミドルカットの開口部
  vampStrapReinforcement(ctx, state) // 紐・ベルト
  toeGuard(ctx, state) // P革
  foldingTongue(ctx, state, 0, 0) // 折りベロ

  if (isLeftToeGuard) {
    undoInversion(ctx, canvasWidth)
  }
}
